import React, { useEffect, useMemo, useRef, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Comments from "./Comments";

function FormTextArea({
  id,
  name,
  label,
  error,
  onChange,
  commentsFactory,
  identical,
  value,
  className,
  divClassName,
  labelClassName,
  printClassName,
  rows,
  defaultValue,
  tooltip,
  maxCharacters,
  subLabel,
  subLabelPosition,
  customMarginBottom,
  ...rest
}) {
  const [showComments, setShowComments] = useState(false);
  const [scrollHeight, setScrollHeight] = useState();
  const textAreaRef = useRef();

  const textAreaValue = useMemo(() => {
    return value || defaultValue || "";
  }, [value, defaultValue]);

  useEffect(() => {
    setTimeout(() => {
      if (textAreaValue && textAreaRef.current?.scrollHeight) {
        setScrollHeight(`${textAreaRef.current.scrollHeight + 1.5}px`);
      }
    }, 50);
  }, [textAreaValue]);

  const controlStyle = useMemo(() => {
    const textAreaStyle = { overflow: "hidden", height: scrollHeight };
    return textAreaStyle;
  }, [scrollHeight]);

  const maxCharactersMarkup = useMemo(() => {
    if (!maxCharacters || !textAreaValue) {
      return null;
    }

    const textColor =
      textAreaValue.length >= maxCharacters
        ? "text-danger"
        : textAreaValue.length >= maxCharacters * 0.75
        ? "text-warning"
        : "text-black";

    return (
      <div className="clearfix">
        <div className={`float-end ${textColor}`}>
          {textAreaValue.length}/{maxCharacters}
        </div>
      </div>
    );
  }, [maxCharacters, textAreaValue]);

  const toggleComments = () => {
    setShowComments(!showComments);
  };

  const comments = commentsFactory?.get(name);

  return (
    <div
      {...rest}
      className={`${customMarginBottom ? customMarginBottom : "mb-3"}${
        divClassName ? ` ${divClassName}` : ""
      }`}
    >
      {comments && showComments ? (
        <Comments comments={comments} commentsFactory={commentsFactory} />
      ) : null}
      {identical && (
        <i className="fab fa-searchengin text-danger float-end mb-2 ms-2 d-print-none"></i>
      )}
      {label && (
        <div className="form-label">
          <label
            htmlFor={id || name}
            title={tooltip !== undefined ? tooltip : ""}
            className={labelClassName}
          >
            {label}{" "}
            {tooltip !== undefined ? (
              <i className="fas fa-info-circle"></i>
            ) : null}
            {comments?.length > 0 ? (
              <i
                className="fas fa-comment-alt text-warning m-2"
                onClick={toggleComments}
              />
            ) : null}
          </label>
          {subLabel && subLabelPosition === "label" ? (
            <>
              <br />
              <label
                htmlFor={id || name}
                title={tooltip !== undefined ? tooltip : ""}
                className="form-label fst-italic"
              >
                {subLabel}
              </label>
              <br />
            </>
          ) : null}
        </div>
      )}
      <textarea
        {...rest}
        name={name}
        id={id || name}
        value={textAreaValue}
        ref={textAreaRef}
        className={`d-print-none ${
          className
            ? `${className} form-control border-secondary`
            : "form-control border-secondary"
        }`}
        onChange={onChange}
        style={controlStyle}
        rows={rows || "1"}
      />
      {textAreaValue !== undefined && textAreaValue !== "" && (
        <span
          className={`d-none d-print-inline${
            printClassName ? ` ${printClassName}` : ""
          }`}
          style={{ whiteSpace: "pre-line" }}
        >
          {textAreaValue}
        </span>
      )}
      {subLabel && (!subLabelPosition || subLabelPosition === "control") ? (
        <label
          htmlFor={id || name}
          title={tooltip !== undefined ? tooltip : ""}
          className="form-label"
        >
          {subLabel}
        </label>
      ) : null}
      {maxCharactersMarkup}
      {error && <div className="mt-1 alert alert-danger">{error}</div>}
    </div>
  );
}

export default FormTextArea;
